/*
|--------------------------------------------------------------------------
| Component: Pagination.jsx
| Author: Sayed Ahmed
| Description: Handles pagination UI including page links, navigation,
| and display of current item range based on total and per page.
|--------------------------------------------------------------------------
*/

import React from "react";
import { Link } from "react-router-dom";

export default function Pagination({
  totalItems,
  currentPage,
  perPage,
  onPageChange,
  t = (str) => str, // Optional translation function
}) {
  const totalPages = Math.ceil(totalItems / perPage);

  // Determine the range of currently displayed items
  const startItem = totalItems === 0 ? 0 : currentPage * perPage + 1;
  const endItem =
    totalItems > (currentPage + 1) * perPage
      ? (currentPage + 1) * perPage
      : totalItems;

  // Generate an array [0, 1, ..., totalPages - 1]
  const paginationRange = [...Array(totalPages).keys()];

  return (
    <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-2">
      {/* Showing X to Y of Z entries */}
      <div className="dataTables_info">
        {t("Showing")} {startItem} {t("To")} {endItem} {t("Of")} {totalItems} {t("Entries")}
      </div>

      {/* Pagination controls */}
      <div className="dataTables_paginate paging_simple_numbers mb-0" id="example5_paginate">
        {/* Previous button */}
        <Link
          to="#"
          className={`paginate_button previous ${currentPage === 0 ? "disabled" : ""}`}
          onClick={() => currentPage > 0 && onPageChange(currentPage - 1)}
        >
          <i className="fa fa-angle-double-left" aria-hidden="true" />
        </Link>

        {/* Page number buttons */}
        <span>
          {paginationRange.map((page) => (
            <Link
              key={page}
              to="#"
              className={`paginate_button ${currentPage === page ? "current" : ""}`}
              onClick={() => onPageChange(page)}
            >
              {page + 1}
            </Link>
          ))}
        </span>

        {/* Next button */}
        <Link
          to="#"
          className={`paginate_button next ${currentPage + 1 >= totalPages ? "disabled" : ""}`}
          onClick={() => currentPage + 1 < totalPages && onPageChange(currentPage + 1)}
        >
          <i className="fa fa-angle-double-right" aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
}
